<template>
  <div>
    <div :class="'grid_inner ' + (isExtra ? '' : 'fw500')">
      <div class="cell" :class="editable.approved ? '' : 'secondary lighten-5 secondary--text text-darken-2'">
        <BaseCheckbox
          v-model="approved.value"
          class="mr-2"
          @input="setApproveChanges(!approved.value, false)"
          :disabled="!editable.approved"
        />
        {{
          work.is_hourly === 1 || isExtra
            ? $formatTime(report['employee_report'])
            : report['employee_report'] + ' ' + work.measure
        }}
      </div>
      <v-text-field
        v-if="edit.approved"
        v-model="edit.data"
        dense hide-details outlined
        :autofocus="!dialog"
        class="f14 none_border"
        :type="work.is_hourly === 1 || isExtra ? 'time' : 'numeric'"
        @change="changeValue(edit.data, false)"
        @blur="changeValue(edit.data, false)"
      />
      <v-hover v-else v-slot="{ hover }">
        <div
          @click="editable.approved ? onEdit(work.is_hourly === 1 || isExtra, false) : null"
          class="cell d-flex justify-space-between"
          :class="(report['employee_report'] === report['approved_report'] || report['approved_report'] === 0
          ? ''
          : report['employee_report'] > report['approved_report']
            ? 'red lighten-5'
            : 'green lighten-5') + (editable.approved ? ' pointer' : '')"
        >
          <div class="d-flex align-center">
            <template v-if="report['approved_report'] > 0">
              {{
                work.is_hourly === 1 || isExtra
                  ? $formatTime(report['approved_report'])
                  : report['approved_report'] + ' ' + work.measure
              }}
            </template>
          </div>
          <div>
            <v-btn @click.stop="showNote = true, dialog = true" v-if="report['approved_notes']" icon small
                   class="ml-n1 my-n1" :class="editable.approved ? '' : 'mr-n1'">
              <v-icon color="#277FAF">mdi-information</v-icon>
            </v-btn>
            <v-icon v-if="editable.approved" size="18" class="ml-auto" :color="hover ? 'primary' : ''">mdi-pencil
            </v-icon>
          </div>
        </div>
      </v-hover>
      <div class="cell">{{ work.name }}</div>
      <div class="cell text-pre">Block <span class="text-uppercase">{{ work.name[0] }}</span></div>
      <v-text-field
        v-if="editable.approved && editWorkNote"
        v-model="editWorkNoteValue"
        dense hide-details outlined
        :autofocus="true"
        class="f14 none_border"
        @blur="onEditNote(), editWorkNote = false"
      />
      <v-hover v-else v-slot="{ hover }">
        <div class="cell" @click="editWorkNote = editable.approved" :class="editable.approved ? ' pointer' : ''">
          {{ report['employee_work_day_reports_notes'] || report['work_extras_report_notes'] }}
          <v-icon v-if="editable.approved" size="18" class="ml-auto" :color="hover ? 'primary' : ''">mdi-pencil</v-icon>
        </div>
      </v-hover>
      
    </div>
    <v-dialog width="600" v-if="dialog" v-model="dialog">
      <v-card class="pt-4 px-4 pb-4">
        <v-btn icon absolute right top class="mt-n2 mr-n2" @click="resetEdit">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="d-flex justify-center pb-4">
          <v-icon large color="#277FAF">mdi-information</v-icon>
        </div>
        <template v-if="showNote">
          <v-textarea
            v-if="notePaid"
            v-model="report['paid_notes']"
            auto-grow outlined hide-details readonly
            rows="4"
          />
          <v-textarea
            v-else
            v-model="report['approved_notes']"
            auto-grow outlined hide-details readonly
            rows="4"
          />
        </template>
        <v-textarea
          v-else
          v-model="edit.note"
          auto-grow outlined hide-details autofocus
          rows="4"
        />
        <template v-if="showNote">
          <div class="text-end f12 my-2">
            <div>
              {{ report['approved_by_user'].first_name + ' ' + report['approved_by_user'].last_name }}
            </div>
            <div>
              {{ report['approved_datetime'] }}
            </div>
          </div>
          <div class="d-flex justify-center">
            <v-hover v-slot="{ hover }">
              <v-btn
                fab :outlined="!hover"
                color="#277FAF"
                dark
                @click="resetEdit"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-hover>
          </div>
        </template>
        <div v-else class="d-flex justify-space-around mt-4">
          <v-hover v-slot="{ hover }">
            <v-btn fab :outlined="!hover" :depressed="!hover" dark color="red" @click="resetEdit">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot="{ hover }">
            <v-btn
              fab :depressed="!hover" :outlined="!hover"
              color="#26bc2c"
              :disabled="!edit.note"
              :dark="!!edit.note"
              @click="setApproveChanges(false, notePaid)"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-hover>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BaseCheckbox from "../../../../base/BaseCheckbox";
import {mapActions} from "vuex";

export default {
  name: "StatisticProjectReportsBlankExcelTableByDaysItem",
  components: {BaseCheckbox},
  props: {
    isExtra: Boolean,
    work: {
      type: Object,
      default: () => {
        return {}
      }
    },
    report: {
      type: Object,
      default: () => {
        return {}
      }
    },
    onUpdate: {},
    employee_id: {
      type: Number,
      default: 0
    },
  },
  data: () => ({
    edit: {
      approved: false,
      paid: false,
      data: 0,
      note: '',
    },
    showNote: false,
    dialog: false,
    notePaid: false,
    editWorkNote: false,
    editWorkNoteValue: '',
  }),
  computed: {
    approved() {
      let temp = 0
      if (typeof this.report['approved_report'] === 'string') {
        temp = this.report['approved_report'].split(':')
        temp = Number(temp[0]) * 60 + Number(temp[1])
      }
      return {value: this.report['approved_report'] > 0 || temp > 0}
    },
    paid() {
      let temp = 0
      if (typeof this.report['paid_report'] === 'string') {
        temp = this.report['paid_report'].split(':')
        temp = Number(temp[0]) * 60 + Number(temp[1])
      }
      return {value: this.report['paid_report'] > 0 || temp > 0}
    },
    editable() {
      return {
        approved: this.report['client_report_status'] === null,
        paid: this.report['client_report_status'] === 'signed',
      }
    }
  },
  created() {
    if (this.report.type === 'work_types') {
      this.editWorkNoteValue = this.report['employee_work_day_reports_notes']
    } else {
      this.editWorkNoteValue =this.report['work_extras_report_notes']
    }
  },
  methods: {
    ...mapActions('employeeWorkDay', ['onEmployeeWorkDay_periodReport_post', 'onEmployeeWorkDay_extra_update']),
    ...mapActions('workClientProjectsPeriodReport', ['onWorkClientProjectsPeriodReportShow']),
    onEdit(hourly, paid) {
      let value = this.report['paid_report'] || this.report['approved_report'] || this.report['employee_report']
      if (hourly) {
        this.edit.data = String(Math.floor(value / 60)).padStart(2, '0')
          + ':'
          + String(value % 60).padStart(2, '0')
      } else this.edit.data = value
      this.edit.note = paid ? '' : this.report['approved_notes'] || ''
      this.edit[paid ? 'paid' : 'approved'] = true
    },
    async onEditNote() {
      if (this.report.type === 'work_types') {
        let data = {
          employee_id: this.employee_id,
          employee_work_day_id: this.report.employee_work_day_id,
          report: this.editWorkNoteValue,
          employee_period_id: this.report.employee_period_id
        }
        await this.onEmployeeWorkDay_periodReport_post(data).then(() => {
          this.onWorkClientProjectsPeriodReportShow(this.$route.params.report_id).then(() => {})
        })
      } else {
        let data = {
          id: this.report.id,
          report: this.editWorkNoteValue,
        }
        await this.onEmployeeWorkDay_extra_update(data).then(() => {
          this.onWorkClientProjectsPeriodReportShow(this.$route.params.report_id)
        })
      }
      
    },
    formatValue(value) {
      let temp = Number(value)
      if (this.work.is_hourly === 1 || this.isExtra) {
        if (typeof value === 'string') {
          temp = value.split(':')
          temp = Number(temp[0]) * 60 + Number(temp[1])
        }
      }
      return temp
    },
    
    changeValue(value, paid) {
      let control = paid ? this.report['paid_report'] : this.report['approved_report']
      if (this.formatValue(value) === control)
        this.resetEdit()
      else {
        let data = paid ? this.report['approved_report'] : this.report['employee_report']
        if (this.formatValue(value) > 0) {
          if (this.formatValue(value) !== data) {
            this.notePaid = paid
            this.dialog = true
          } else this.setApproveChanges(false, paid)
        } else this.setApproveChanges(true, paid)
      }
    },
    async setApproveChanges(onClear, paid) {
      let field = paid ? 'paid' : 'approved'
      let value = paid ? this.report['approved_report'] : this.report['employee_report']
      let data = {}
      data.id = this.report.id
      if (this.work.is_hourly === 1 || this.isExtra)
        data[field + '_hours'] = onClear ? 0 : this.formatValue(this.edit.data) || value
      else data[field + '_size'] = onClear ? 0 : this.formatValue(this.edit.data) || value
      data[field + '_notes'] = onClear || this.formatValue(this.edit.data) === 0 ? '' : this.edit.note
      if (this.onUpdate) this.onUpdate(Array(data), onClear ? false : value > 0, paid, this.isExtra)
    },
    
    resetEdit() {
      this.edit = {
        approved: false,
        paid: false,
        data: 0,
        note: ''
      }
      this.showNote = false
      this.dialog = false
      this.notePaid = false
    }
  }
}
</script>
